import { render } from "./CardObject.vue?vue&type=template&id=1aeb7d69&scoped=true"
import script from "./CardObject.vue?vue&type=script&lang=js"
export * from "./CardObject.vue?vue&type=script&lang=js"

import "./CardObject.vue?vue&type=style&index=0&id=1aeb7d69&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aeb7d69"]])

export default __exports__